import { Component } from '@angular/core';
import { SearchViewComponent } from '../search-view.component';

@Component({
  selector: 'app-search-view',
  templateUrl: '../search-view.component.html',
  styleUrls: ['../search-view.component.scss'],
})
export class SearchViewMobileComponent extends SearchViewComponent {}
